import type { IconData } from '@stacksjs/iconify-core'

export const candleFlat: IconData = {
  "body": "<g fill=\"none\"><path fill=\"#8fbffa\" d=\"M39.33 30.742c-.235-3.16-2.923-5.277-5.938-5.173c-6.536.226-13.269 1.003-19.478 2.251c-2.772.558-5 2.756-5.246 5.714a52 52 0 0 0-.168 4.282V46a1.5 1.5 0 0 0 1.5 1.5h28a1.5 1.5 0 0 0 1.5-1.5V35.77c0-2.038-.072-3.703-.17-5.028\"/><path fill=\"#2859c5\" d=\"M25.522 3.03a2.5 2.5 0 0 0-.71-1.857A2.25 2.25 0 0 0 22.694.56a5.9 5.9 0 0 0-1.651.664c-2.98 1.762-8.543 5.895-8.543 12.53c0 3.293 1.321 5.812 3.532 7.461c2.15 1.605 5.003 2.287 7.968 2.287s5.818-.682 7.968-2.287c2.21-1.65 3.532-4.168 3.532-7.461c0-3.139-1.258-5.726-2.862-7.737a2.38 2.38 0 0 0-2.494-.823a2.55 2.55 0 0 0-1.79 1.755c-.233.799-.514 1.557-.843 2.186c-.232.443-.461.771-.675 1c-.523-.697-.893-1.746-1.108-3.03c-.237-1.409-.255-2.902-.206-4.075\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default candleFlat
